import { Observable } from 'rxjs';

export class CancellationToken {
  private _isCancelled: boolean;

  get isCancelled(): boolean {
    return this._isCancelled;
  }

  cancel(): void {
    this._isCancelled = true;
  }
}

/**
 * Creates cancellable long-running operation.
 * In order to cancel an operation, cancellationToken.cancel() should be called, and the operation itself
 * must not be blocking (should use macrotasks like setTimeout).
 * When operation is done, emits the value and completes.
 * When operation is cancelled, it does not emit anything and completes.
 * @param operationCallback
 * @returns 
 */
export function createCancellableOperation<T>(
  operationCallback: (cancellationToken?: CancellationToken) => Promise<T>,
): Observable<T> {
  return new Observable((subscriber) => {
    const cancellationObject = new CancellationToken();

    operationCallback(cancellationObject).then((result) => {
      if (!cancellationObject.isCancelled) {
        subscriber.next(result);
      }
      
      subscriber.complete();
    });

    return () => cancellationObject.cancel();
  });
}
